export const handleApiError = (error: unknown) => {
  if (error instanceof Error) {
    throw new Error(error.message);
  }

  if (typeof error === "string") {
    throw new Error(error);
  }

  throw new Error("Unexpected error");
};

export class ApiError extends Error {
  status: number;
  data?: unknown;

  constructor(message: string, status: number, data?: unknown) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.data = data;
  }
}